import { useEffect } from 'react'
import { RouterProvider } from '@tanstack/router'
import smoothscroll from 'smoothscroll-polyfill'

import withLogin from './hoc/withLogin'
import { router } from './router'
import { setAdvertisingId } from './utils/send-event-to-native-app'

smoothscroll.polyfill()

function App() {
  useEffect(() => {
    setAdvertisingId()
  }, [])

  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}

export default withLogin(App)
